import posed from 'react-pose';

const PosedDiv = posed.div({
  enter: { y: 0, opacity: 1 },
  exit: { y: 50, opacity: 0 },
});

export default PosedDiv;
